<script setup async lang="ts">
import {getting} from "@/Composables/api";
import {PageLoading} from "@/Components/Global";
import {RouterLink} from "vue-router";
import {Checkbox, Button} from "@/Components/Library";
import GroupItem from "@/Pages/User/Groups/GroupItem.vue";

const model = defineModel();
const props = defineProps<{groups: any}>();
</script>
<template>
    <div>
        <PageLoading v-if="getting.includes('groups')" />
        <div
            v-if="!(getting.includes('groups') && !getting.includes('questions')) && groups.length"
            class="grid grid-cols-1 gap-3 md:grid-cols-2"
            v-auto-animate
        >
            <template v-for="group in groups" :key="group.id">
                <button
                    type="button"
                    class="items--center flex gap-2 rounded border text-left"
                    :class="
                        model === group.id
                            ? 'border-askr-green bg-askr-green text-white'
                            : 'bg-white dark:border-stone-800 dark:bg-stone-900 dark:text-stone-300'
                    "
                    @click="model === group.id ? (model = null) : (model = group.id)"
                >
                    <GroupItem :group="group" :showMenu="false" />
                    <div class="ml-auto mr-2 flex flex-col items-end justify-end py-3">
                        <Checkbox v-model="model" :value="group.id" class="" />
                        <RouterLink
                            :to="{
                                name: 'feed',
                                params: {group: group.id},
                            }"
                            class="mt-auto text-sm font-semibold leading-none"
                        >
                            <Button class="h-8 w-8" icon="mingcute:arrow-right-fill" />
                        </RouterLink>
                    </div>
                </button>
            </template>
        </div>
        <div
            v-else-if="!(getting.includes('groups') && !getting.includes('questions')) && !groups.length"
            class="flex flex-col items-stretch"
        >
            <p class="mb-2 mt-4 text-center">No groups found.</p>
        </div>
    </div>
</template>
<style scoped></style>
